import Vue from "vue";
import Router from "vue-router";
import firebase from "firebase";
import Home from "./views/Home.vue";
import NewItem from "./views/dashboard/New.vue";
import Profile from "./views/dashboard/descriptions/Profile.vue";
import DashBoard from "./views/dashboard/Main.vue";
import ConfigProfile from "./views/dashboard/config/ConfigProfile.vue";
import ConfigAccount from "./views/dashboard/config/ConfigAccount.vue";
import RestorePassword from "./views/RestorePassword.vue";
import PageNotFound from "./components/404.vue";
import { store } from "./store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    },
    {
      path: "/contact",
      component: () => import("./views/Contact.vue"),
      name: "Contact"
    },
    {
      path: "/signin",
      name: "signin",
      meta: { requiresAnon: true },
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/SignIn.vue")
    },
    {
      path: "/signup",
      name: "signup",
      meta: { requiresAnon: true },
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/SignUp.vue")
    },
    {
      path: "/new",
      component: NewItem,
      meta: { requiresAuth: true },
      name: "NewItem"
    },
    {
      path: "/profile",
      component: Profile,
      meta: { requiresAuth: true },
      name: "Profile"
    },
    { path: "/config", redirect: "/config/profile" },
    {
      path: "/config/profile",
      component: ConfigProfile,
      meta: { requiresAuth: true },
      name: "ConfigProfile"
    },
    {
      path: "/config/account",
      component: ConfigAccount,
      meta: { requiresAuth: true },
      name: "ConfigAccount"
    },
    {
      path: "/dashboard",
      component: DashBoard,
      meta: { requiresAuth: true },
      name: "DashBoard"
    },
    {
      path: "/dashboard/sensors",
      component: () => import("./views/dashboard/lists/SensorsList.vue"),
      meta: { requiresAuth: true },
      name: "SensorsList"
    },
    {
      path: "/dashboard/groups",
      component: () => import("./views/dashboard/lists/GroupsList.vue"),
      meta: { requiresAuth: true },
      name: "GroupsList"
    },
    {
      path: "/dashboard/buildings",
      component: () => import("./views/dashboard/lists/BuildingsList.vue"),
      meta: { requiresAuth: true },
      name: "BuildingsList"
    },
    {
      path: "/dashboard/sensors/sensor",
      component: () => import("./views/dashboard/descriptions/Sensor.vue"),
      meta: { requiresAuth: true },
      name: "Sensor"
    },
    {
      path: "/dashboard/groups/group",
      component: () => import("./views/dashboard/descriptions/Group.vue"),
      meta: { requiresAuth: true },
      name: "Group"
    },
    {
      path: "/dashboard/buildings/building",
      component: () => import("./views/dashboard/descriptions/Building.vue"),
      meta: { requiresAuth: true },
      name: "Building"
    },
    {
      path: "/dashboard/buildings/edit",
      component: () => import("./views/dashboard/config/building/EditBuilding.vue"),
      meta: { requiresAuth: true },
      name: "EditBuilding"
    },
    {
      path: "/dashboard/buildings/sensors",
      component: () => import("./views/dashboard/config/building/AddSensorsBuilding.vue"),
      meta: { requiresAuth: true },
      name: "AddSensorsBuilding"
    },
    {
      path: "/dashboard/buildings/location",
      component: () => import("./views/dashboard/config/building/BuildingLocation.vue"),
      meta: { requiresAuth: true },
      name: "BuildingLocation"
    },
    {
      path: "/dashboard/groups/edit",
      component: () => import("./views/dashboard/config/group/EditGroup.vue"),
      meta: { requiresAuth: true },
      name: "EditGroup"
    },
    {
      path: "/dashboard/groups/sensors",
      component: () => import("./views/dashboard/config/group/AddSensorsGroup.vue"),
      meta: { requiresAuth: true },
      name: "AddSensorsGroup"
    },
    {
      path: "/dashboard/sensors/edit",
      component: () => import("./views/dashboard/config/sensor/EditSensor.vue"),
      meta: { requiresAuth: true },
      name: "EditSensor"
    },
    {
      path: "/dashboard/sensors/schedules",
      component: () => import("./views/dashboard/config/sensor/Schedules.vue"),
      meta: { requiresAuth: true },
      name: "Schedules"
    },
    {
      path: "/dashboard/sensors/building",
      component: () => import("./views/dashboard/config/sensor/ViewSensorLocation.vue"),
      meta: { requiresAuth: true },
      name: "ViewSensorLocation"
    },
    {
      path: "/notifications",
      component: () => import("./views/dashboard/lists/NotificationsList.vue"),
      meta: { requiresAuth: true },
      name: "NotificationsList"
    },
    { path: "/restore", component: RestorePassword, name: "RestorePassword" },
    {
      path: "/new/sensor",
      component: () => import("./views/dashboard/new/NewSensor.vue"),
      meta: { requiresAuth: true },
      name: "NewSensor"
    },
    {
      path: "/new/group",
      component: () => import("./views/dashboard/new/NewGroup.vue"),
      meta: { requiresAuth: true },
      name: "NewGroup"
    },
    {
      path: "/new/building",
      component: () => import("./views/dashboard/new/NewBuilding.vue"),
      meta: { requiresAuth: true },
      name: "NewBuilding"
    },
    {
      path: "/confirmations/created",
      name: "created",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/confirmations/AccountCreated.vue")
    },
    {
      path: "/confirmations/deleted",
      name: "deleted",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/confirmations/AccountDeleted.vue")
    },
    {
      path: "/confirmations/reset",
      name: "reset",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/confirmations/PasswordResetSended.vue")
    },
    { path: "/404", component: PageNotFound, name: "404" },
    { path: "*", component: PageNotFound }
  ]
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresAnon = to.matched.some(record => record.meta.requiresAnon);
  const isAuthenticated = firebase.auth()
    .currentUser;
  if (requiresAuth && !isAuthenticated) {
    store.commit("setError", "Necesitas iniciar sesión para eso.");
    next("/signin");
  } else {
    next();
  }
  if (requiresAnon && isAuthenticated) {
    next("/profile");
  } else {
    next();
  }
});

export default router;
